import { Empleado } from '../empleado';
import { SolicitudAsigEquipo } from './solicitud-asig-equipo';

/* Datos que se llaman directo del backend */
export class RegistroAsignacionEquipo {
  /*Identificador único del registro de asignación */
  id_registro_asignacion: number | undefined;
  /*Observaciones generales del registro de asignación */
  observaciones: string | undefined;
  /*Identificador del empleado que se le asigna el equipo */
  colaborador_id: number | undefined;
  /*Identificador del empleado que asignó el equipo */
  administrador_TI: number | undefined;
  /*Estado del registro de asignación */
  status_registro: string | undefined;
  /*fecha en que se realizó la asignación */
  fecha_asignacion: Date | undefined;
  /*última fecha de modificación */
  fecha_modificacion: Date | undefined;
  solicitud: SolicitudAsigEquipo = new SolicitudAsigEquipo();
  /* Campos extras para mostrar en las vistas */
  /*Nombre del empleado que se le asigna el equipo */
  nombre_empleado_asignado: string | undefined;
  /*Nombre del empleado que asignó el equipo */
  nombre_empleado_registra: string | undefined;
  /*Causa por la cual tiene pendiente de responsiva */
  razon: string | undefined;
  /*Indica si tiene solicitud */
  cuenta_solicitud: string = 'NO';
  /*Feca de asignación */
  fecha_asignacion_cadena: string | undefined;
  /*Última fecha de modificación */
  fecha_modificacion_cadena: string | undefined;
}
